<fgb-mobile-nav-menu *ifScreenSize="screenType.Mobile"></fgb-mobile-nav-menu>
<fgb-banner [isHomePage]="true"></fgb-banner>
<div class="mixed-nav card-member d-block d-lg-none order-1 bg-primary">
  <fgb-barcode [isHomePage]="true"></fgb-barcode>
</div>

<!--Scorecard-->
<fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

<!-- Rewards -->
<fgbcl-featured-rewards></fgbcl-featured-rewards>

<!-- Offers list -->
<fgb-campaigns-v2-offers-list [showAllOffers]="true"></fgb-campaigns-v2-offers-list>

<!-- Announcements -->
<div class="container">
  <fgbcl-announcements></fgbcl-announcements>
</div>

<!-- Vouchers -->
<div class="voucher-container">
  <fgb-vouchers></fgb-vouchers>
</div>
